import React from 'react';
import { Switch } from 'antd';
import './AutopasteSwitch.css';
import useAutopaste from '../../hooks/useAutopaste';

const AutopasteSwitch = React.memo(() => {
  const { enabled, handleChange } = useAutopaste();

  return (
    <div className="AutopasteSwitch">
      <Switch
        aria-label="Autopaste"
        title="Autopaste"
        checked={enabled}
        checkedChildren="A"
        unCheckedChildren="A"
        onChange={handleChange}
      />
    </div>
  );
});

export default AutopasteSwitch;
